import axios from 'axios';
import setupAxios from './axios';

export default {
  axios, // The instance
  setupAxios, // The setup function
};